import { render, staticRenderFns } from "./FooterGeneral.vue?vue&type=template&id=58488cd6&"
import script from "./FooterGeneral.vue?vue&type=script&lang=js&"
export * from "./FooterGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports